import { render, staticRenderFns } from "./DictionaryEdit.vue?vue&type=template&id=7be54462&scoped=true"
import script from "./DictionaryEdit.vue?vue&type=script&lang=js"
export * from "./DictionaryEdit.vue?vue&type=script&lang=js"
import style0 from "./DictionaryEdit.vue?vue&type=style&index=0&id=7be54462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be54462",
  null
  
)

export default component.exports